<div class="messages__header" i18n="@@CHAT.LIST.MESSAGES">Messages</div>
<vc-notifications
  [isShow]="true"
  [showHeader]="false"
  [activableNotifications]="true"
  [channelId]="channelId"
  defaultCategory="messages"
></vc-notifications>
